const taKundli = {
  // Errors & validation
  "please_fill_required_fields": "தயவுசெய்து தேவையான அனைத்து புலங்களையும் நிரப்பவும்.",
  "invalid_email_format": "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
  "invalid_phone_format": "சரியான தொலைபேசி எண்ணை உள்ளிடவும்.",
  "payment_failed_message": "கட்டணம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும் அல்லது உதவியை தொடர்பு கொள்ளவும்.",

  // Header & hero
  "cosmic_career": " கொண்ட ஜாதக அறிக்கை",
  "journey": "உங்கள் முழுமையான வாழ்க்கை பகுப்பாய்வு",
  "discover_professional_destiny": "தனிப்பட்ட வேத ஜோதிட அறிக்கை — தொழில், உறவுகள், உடல்நலம் மற்றும் பரிகாரங்கள் — 24 மணி நேரத்திற்குள் கிடைக்கும்.",

  // Form labels
  "full_name": "முழு பெயர்",
  "enter_complete_name": "உங்கள் முழு பெயரை உள்ளிடவும்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "email_address": "மின்னஞ்சல் முகவரி",
  "email_placeholder": "ungal@email.com",
  "phone_number": "தொலைபேசி எண்",
  "phone_placeholder": "+91 1234567890",
  "your_birth_date": "உங்கள் பிறந்த தேதி",
  "birth_time": "பிறந்த நேரம்",
  "birth_place": "பிறந்த இடம்",
  "city_state_country": "நகரம், மாநிலம், நாடு",
  "preferred_language": "விருப்பமான மொழி",
  "english": "🇺🇸 ஆங்கிலம்",
  "hindi": "🇮🇳 ஹிந்தி",
  "telugu": "🇮🇳 தெலுங்கு",
  "kannada": "🇮🇳 கன்னடம்",
  "tamil": "🇮🇳 தமிழ்",
  "marathi": "🇮🇳 மராத்தி",
  "bengali": "🇮🇳 பெங்காலி",

  // Benefits (what you'll receive)
  "what_youll_receive": "நீங்கள் பெறுவதெல்லாம்",
  "life_kundali_20_years": "முழுமையான ஜாதகம் — தொழில், உறவுகள், உடல்நலம் மற்றும் நிதி தொடர்பான நீண்டகால வழிகாட்டுதல்.",
  "detailed_career_path_analysis": " கொண்ட PDF — ஜாதக சக்கரம், யோகங்கள், தசைகள், கோசாரங்கள் மற்றும் விளக்கப்படங்களுடன்.",
  "planetary_position_interpretations": "கிரக நிலைகள் மற்றும் பாவங்களின் தெளிவான விளக்கம் — எளிதில் படிக்கக்கூடிய வடிவில்.",
  "dasha_system_predictions": "தசை மற்றும் கோசார அடிப்படையிலான கணிப்புகள் — சரியான நேரத்தில் சரியான முடிவுகளுக்கான வழிகாட்டல்.",
  "personalized_remedial_suggestions": "தனிப்பட்ட பரிகாரங்கள் மற்றும் ரத்தின பரிந்துரைகள் — சிரமமான காலங்களை சமநிலைப்படுத்த.",
  "digital_pdf_report": "டிஜிட்டல் PDF — வாட்ஸ்அப் அல்லது மின்னஞ்சல் மூலம் 24 மணி நேரத்திற்குள் அனுப்பப்படும்.",

  // Pricing/checkout
  "unlock_your_destiny_title": "உங்கள் முழு அறிக்கையைப் பெறுங்கள்",
  "complete_cosmic_journey_desc": "படிவத்தை பூர்த்தி செய்து உங்கள் தனிப்பட்ட  கொண்ட ஜோதிட அறிக்கையைப் பெறுங்கள்.",
  "premium": "பிரீமியம் அறிக்கை",
  "career_path_analysis": "முழுமையான வாழ்க்கை பகுப்பாய்வு அறிக்கை",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது...",
  "preparing_analysis": "உங்கள்  கொண்ட அறிக்கை தயாராகிறது...",
  "complete_payment_get_report": "🚀 கட்டணத்தை முடித்து அறிக்கையைப் பெறுங்கள்",

  // Trust indicators
  "reports_generated": "15,000+ அறிக்கைகள் வழங்கப்பட்டுள்ளன",
  "rating": "பயனர்களால் 4.9/5 மதிப்பீடு",
  "secure": "🔒 பாதுகாப்பான கட்டண முறை",

  // API / runtime messages
  "failed_to_load_payment": "கட்டண நுழைவாயில் ஏற்றப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "failed_to_create_order": "ஆர்டர் உருவாக்கப்படவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  "failed_to_initialize_payment": "கட்டணம் தொடங்கப்படவில்லை. சிறிது நேரம் கழித்து முயற்சிக்கவும்.",
  "failed_to_open_payment_gateway": "கட்டண சாளரம் திறக்கப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",

  // Service details
  "birth_chart_analysis": "தனிப்பட்ட ஜோதிட அறிக்கை",
  "complete_kundli_report": " கொண்ட வேத ஜாதக அறிக்கை - வாழ்க்கையின் அனைத்து துறைகளும்",
  "service_amount": "₹599",

  "advanced_astrology_suite": "மேம்பட்ட ஜோதிட தொகுப்பு",
  "suite_summary": "காலவரிசைகள், பொருத்தம் மற்றும் தெளிவான பகுப்பாய்வுகளுடன் ஆழமான ஜோதிட அறிக்கைகள் — படிக்கவும் பகிரவும் எளிது.",
  "feature_reports": "முழுமையான அறிக்கைகள் — தெளிவான வடிவமைப்பு மற்றும் விளக்கப்படங்களுடன்.",
  "feature_compatibility": "பொருத்தம் பகுப்பாய்வு மற்றும் காலவரிசைகள் — முக்கிய முடிவுகளுக்கு உதவுகின்றன.",
  "feature_multilingual": "பல மொழிகளில் அறிக்கைகள் மற்றும் மொபைல்/கருவி நட்பு வடிவமைப்பு.",
  "report_preview_alt": "அறிக்கை முன்னோட்டம்",
  "get_my_report": "என் அறிக்கையைப் பெறுங்கள்",
  "autocomplete_hint": "உங்கள் நகரத்தை தட்டச்சு செய்யத் தொடங்குங்கள்; பரிந்துரைகள் தானாக தோன்றும்"
};
export default taKundli;

// const enKundli = {
//   // Error Messages
//   "please_fill_required_fields": "தேவையான அனைத்து புலங்களையும் நிரப்புங்கள்.",
//   "invalid_email_format": "சரியான மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்.",
//   "invalid_phone_format": "சரியான தொலைபேசி எண்ணை உள்ளிடுங்கள்.",
//   "payment_failed_message": "கட்டணம் தோல்வியடைந்தது. மீண்டும் முயலுங்கள் அல்லது ஆதரவைத் தொடர்புகொள்ளுங்கள்.",

//   // Step Configuration
//   "personal_identity": "தனிப்பட்ட தகவல்",
//   "tell_us_about_yourself": "தொடங்குவதற்கு உங்களைப் பற்றி சொல்லுங்கள்",
//   "birth_details": "பிறப்பு விவரங்கள்",
//   "your_cosmic_coordinates": "பகுப்பாய்வைத் தொடங்க உங்கள் பிறப்பு விவரங்கள் தேவையாகின்றன",
//   "time_and_place": "பிறந்த நேரம் & இடம்",
//   "when_and_where_arrived": "எப்போது மற்றும் எங்கு பிறந்தீர்கள்?",
//   "your_preferences": "மொழி விருப்பம்",
//   "customize_experience": "அறிக்கைக்கு விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்",
//   "unlock_your_destiny": "உங்கள் 200+ பக்க குண்டலியைப் பெறுங்கள்",
//   "complete_cosmic_journey": "முழு அறிக்கையைப் பெற உங்கள் விவரங்களை பூர்த்தி செய்யுங்கள்",

//   // Step 0: Personal Details
//   "who_are_you": "நீங்கள் யார்?",
//   "start_with_basics": "அடிப்படை விவரங்களை கூறி தொடங்குங்கள்",
//   "full_name": "முழுப் பெயர்",
//   "enter_complete_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
//   "gender": "பாலினம்",
//   "male": "ஆண்",
//   "female": "பெண்",
//   "other": "மற்றவை",
//   "email_address": "மின்னஞ்சல் முகவரி",
//   "email_placeholder": "your@email.com",
//   "phone_number": "தொலைபேசி எண்",
//   "phone_placeholder": "+91 1234567890",

//   // Step 1: Birth Date
//   "your_birth_date": "உங்கள் பிறந்த தேதி",
//   "cosmic_journey_begin": "உங்கள் அண்டப் பயணம் எப்போது தொடங்கியது?",
//   "age_label": "வயது",
//   "years": "ஆண்டுகள்",

//   // Step 2: Time & Place
//   "time_and_place_title": "பிறந்த நேரம் & இடம்",
//   "precise_moment_location": "துல்லியமான நேரமும் இடமும் சரியான கணக்கீடுகளை உறுதி செய்கின்றன",
//   "birth_time": "பிறந்த நேரம்",
//   "select_exact_time": "உங்கள் துல்லியமான பிறந்த நேரத்தைத் தேர்ந்தெடுக்கவும்",
//   "birth_place": "பிறந்த இடம்",
//   "city_state_country": "நகரம், மாநிலம், நாடு",
//   "location_accuracy": "இடத் துல்லியம்",
//   "exact_birthplace_ensures": "துல்லியமான பிறந்த இடம் சரியான கிரக நிலைகளை உறுதி செய்கிறது",

//   // Step 3: Preferences
//   "your_preferences_title": "மொழியைத் தேர்ந்தெடுக்கவும்",
//   "customize_astrological_experience": "உங்கள் தனிப்பயன் அறிக்கைக்கான மொழியைத் தேர்ந்தெடுக்கவும்",
//   "preferred_language": "விருப்பமான மொழி",
//   "english": "🇺🇸 English",
//   "hindi": "🇮🇳 हिंदी",
//   "telugu": "🇮🇳 తెలుగు",
//   "kannada": "🇮🇳 ಕನ್ನಡ",
//   "tamil": "🇮🇳 தமிழ்",
//   "marathi": "🇮🇳 मराठी",
//   "bengali": "🇮🇳 বাংলা",
//   "what_youll_receive": "நீங்கள் பெறுவது",
//   "life_kundali_20_years": "20 ஆண்டுகளுக்கான எதிர்கால முன்னறிவிப்புகளுடன் வாழ்க்கை குண்டலி — தொழில், காதல், ஆரோக்கியம் & செல்வத்திற்கு ஆண்டுதோறும் வழிகாட்டுதல்",
//   "detailed_career_path_analysis": "200+ பக்க PDF குண்டலி அறிக்கை",
//   "planetary_position_interpretations": "20+ ஜோதிட முறைமைகள் அடங்கும்",
//   "dasha_system_predictions": "தொழில், திருமணம், ஆரோக்கியம் & வாழ்க்கை முன்கணிப்புகள் அடங்கும்",
//   "personalized_remedial_suggestions": "தனிப்பயன் பரிகாரங்கள் & ரத்தின பரிந்துரைகள்",
//   "digital_pdf_report": "24 மணிநேரத்தில் WhatsApp அல்லது மின்னஞ்சல் மூலம் வழங்கப்படும்",

//   // Step 4: Payment
//   "unlock_your_destiny_title": "உங்கள் முழு அறிக்கையைப் பெறுங்கள்",
//   "complete_cosmic_journey_desc": "படிவத்தை பூர்த்தி செய்து உங்கள் தனிப்பட்ட 200+ பக்க ஜோதிட அறிக்கையைப் பெறுங்கள்",
//   "premium": "பிரீமியம் அறிக்கை",
//   "career_path_analysis": "முழுமையான வாழ்க்கை பகுப்பாய்வு அறிக்கை",
//   "off_label": "OFF",
//   "summary_of_details": "உங்கள் சுருக்கம்:",
//   "name_label": "பெயர்:",
//   "birth_date_label": "பிறந்த தேதி:",
//   "birth_time_label": "பிறந்த நேரம்:",
//   "birth_place_label": "பிறந்த இடம்:",
//   "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது...",
//   "preparing_analysis": "உங்கள் 200+ பக்க அறிக்கை உருவாக்கப்படுகிறது...",
//   "complete_payment_get_report": "🚀 கட்டணத்தை முடித்து அறிக்கையைப் பெறுங்கள்",

//   // Navigation
//   "previous": "← முந்தையது",
//   "step_of": "படி",
//   "of": "இல்",
//   "next": "அடுத்தது →",
//   "review_and_pay": "சரிபார்த்து கட்டணமிடுங்கள்",

//   // Validation Messages
//   "fill_personal_details": "தேவையான அனைத்து தனிப்பட்ட விவரங்களையும் நிரப்புங்கள்",
//   "select_birth_date": "உங்கள் பிறந்த தேதியைத் தேர்ந்தெடுக்கவும்",
//   "provide_birth_time_place": "துல்லியமான பிறந்த நேரமும் இடமும் வழங்குங்கள்",

//   // Header
//   "cosmic_career": "200+ பக்க குண்டலி அறிக்கை",
//   "journey": "உங்கள் முழுமையான வாழ்க்கை பகுப்பாய்வு",
//   "discover_professional_destiny": "தொழில், காதல், ஆரோக்கியம் மற்றும் பரிகாரங்களுடன் கூடிய உங்கள் தனிப்பயன் வேத ஜோதிட அறிக்கையைப் பெறுங்கள் — 24 மணிநேரத்தில் வழங்கப்படும். 20 ஆண்டுகளுக்கான எதிர்கால முன்னறிவிப்புகளுடன் வாழ்க்கை குண்டலி — தொழில், காதல், ஆரோக்கியம் & செல்வத்திற்கு ஆண்டுதோறும் வழிகாட்டுதல்",

//   // Trust Indicators
//   "reports_generated": "15,000+ அறிக்கைகள் வழங்கப்பட்டவை",
//   "rating": "பயனர்களால் 4.9/5 மதிப்பீடு",
//   "secure": "🔒 பாதுகாப்பான கட்டணம்",

//   // Thank You Page Service Features
//   "detailed_career_guidance_pdf": "முழுமையான தொழில் & வாழ்க்கைப் பாதை வழிகாட்டுதல்",
//   "comprehensive_astrological_analysis": "20+ ஜோதிட முறைமைகளை அடிப்படையாகக் கொண்டது",
//   "planetary_positions_interpretations": "தசா, கோச்சாரம், நட்சத்திரம், எண்ணியல் ஆகியவை அடங்கும்",
//   "dasha_system_predictions_feature": "எதிர்கால முன்கணிப்புகள், கிரக காலவரிசைகள்",
//   "personalized_remedial_suggestions_feature": "தனிப்பயன் பரிகாரங்கள், ரத்தினங்கள் & தோஷா அறிக்கைகள்",

//   // API Related Messages
//   "failed_to_load_payment": "கட்டண நுழைவாயில் ஏற்றத் தவறியது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
//   "failed_to_create_order": "ஆர்டரை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
//   "failed_to_initialize_payment": "கட்டணத்தை தொடங்க முடியவில்லை. சிறிது நேரத்தில் முயற்சிக்கவும்.",
//   "failed_to_open_payment_gateway": "கட்டண சாளரத்தைத் திறக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",

//   // Service Details
//   "birth_chart_analysis": "தனிப்பயன் ஜோதிட அறிக்கை",
//   "complete_kundli_report": "200+ பக்க வேத குண்டலி அறிக்கை - அனைத்து வாழ்க்கை தளங்களும்",
//   "service_amount": "₹599",

//   // Time of Day Indicators (for emoji display)
//   "morning": "🌅",
//   "afternoon": "☀️",
//   "evening": "🌆",
//   "night": "🌙",

//   // Days of Week
//   "monday": "திங்கள்",
//   "tuesday": "செவ்வாய்",
//   "wednesday": "புதன்",
//   "thursday": "வியாழன்",
//   "friday": "வெள்ளி",
//   "saturday": "சனி",
//   "sunday": "ஞாயிறு",

//   // Months
//   "january": "ஜனவரி",
//   "february": "பிப்ரவரி",
//   "march": "மார்ச்",
//   "april": "ஏப்ரல்",
//   "may": "மே",
//   "june": "ஜூன்",
//   "july": "ஜூலை",
//   "august": "ஆகஸ்ட்",
//   "september": "செப்டம்பர்",
//   "october": "அக்டோபர்",
//   "november": "நவம்பர்",
//   "december": "டிசம்பர்"
// };
// export default enKundli;
